import {
    PLUSKEY,
    MINUSKEY,
    DOWNKEY,
    ESCKEY,
    SPACEKEY,
    LEFTKEY,
    RIGHTKEY,
    TABKEY,
    UPKEY
} from '../enums/keyEnums';

export function isPlusPressed(e) {
    return e.keyCode === PLUSKEY;
}

export function isMinusPressed(e) {
    return e.keyCode === MINUSKEY;
}

export function isDownPressed(e) {
    return e.keyCode === DOWNKEY;
}

export function isEscPressed(e) {
    return e.keyCode === ESCKEY;
}

export function isSpacePressed(e) {
    return e.keyCode === SPACEKEY;
}

export function isLeftPressed(e) {
    return e.keyCode === LEFTKEY;
}

export function isRightPressed(e) {
    return e.keyCode === RIGHTKEY;
}

export function isTabPressed(e) {
    return e.keyCode === TABKEY;
}

export function isUpPressed(e) {
    return e.keyCode === UPKEY;
}
